import { FluentProvider, Spinner } from '@fluentui/react-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HashRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { TeamsContext } from '../utils/Context';
import { useTeamsContext } from '../utils/useTeamsContext';
import { ataLightTheme } from '../theme/ataTheme';
import ClientSuccess from './routes/ClientSuccess';
import FormPage from './routes/FormPage';
import { RecentClientsTable } from './routes/RecentTable';
import ReviewPage from './routes/ReviewPage';

const queryClient = new QueryClient();

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
    const { loading, theme, themeString, isInitialized } = useTeamsContext();

    return (
        <TeamsContext.Provider value={{ theme, themeString, isInitialized }}>
            <QueryClientProvider client={queryClient}>
                {/* Light theme only: the ATA navy brand drives the whole app regardless of Teams theme. */}
                <FluentProvider
                    theme={ataLightTheme}
                    style={{ background: ataLightTheme.colorNeutralBackground3 }}
                >
                    {loading ? (
                        <Spinner style={{ margin: 100 }} size="large" />
                    ) : (
                        <Router>
                            <Routes>
                                <Route path="/FormPage" element={<FormPage />} />
                                <Route path="/ReviewPage" element={<ReviewPage />} />
                                <Route path="/ClientSuccess" element={<ClientSuccess />} />
                                <Route path="/Recent" element={<RecentClientsTable />}></Route>
                                <Route path="*" element={<Navigate to={'/Recent'} />}></Route>
                            </Routes>
                        </Router>
                    )}
                </FluentProvider>
            </QueryClientProvider>
        </TeamsContext.Provider>
    );
}
